// removed by extract-text-webpack-plugin
module.exports = {"textBox":"S8_f7jk_C-Vx6mVREIseq","headerRow":"Z4AXBUwr5l56YA7WdKusO","headerTitle":"_1lUPILpnJWUluJKk_KxBKj","qpane":"_3HBX0k1v7dKmTmbokzGnI4","qpaneSize":"rJQ8Vs3g0O9NMpIiHLqOa","question":"_1IbEjK4asdhzGIHwHZvbjL","insidepane":"_1h8ZBe3IQi1QpcgXHNGYj3","oneButton":"_2vm_wnCrTWBGE8lF20WYIx","twoButton":"FV1-v_wU8OxwStMcTyLxv","threeButton":"_3fAw1DoCfV97tynKC97gHI","fourButton":"IaAeUYW9mNv1lpiMHi0tK","fiveButton":"_3JTbNjwlfCiZ08J31BLXhE","sixButton":"_1KeYp1JBq2CrSXRxsUi2rl","stepOn":"p1ky0YLtTqHY1jJk-QpfP","stepOff":"_22sn0jD6WEqoZPBbX_nGWF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientMode/LossFrequency.css
// module id = 821
// module chunks = 0